import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/case-studies/dataforce-transcription/page.tsx");
